module.exports = __webpack_public_path__ + "media/img/decorations/howitzer-tabs-img1-cbe80768c190e8f00c0d6dabe23a4d6d.svg";